import { RootState } from '../reducers/rootReducer';

export const getMapState = (state: RootState) => state.map;
export const getViewState = (state: RootState) => getMapState(state).viewState;
export const getBoundingBox = (state: RootState) => getMapState(state).boundingBox;
export const getInitialViewBox = (state: RootState) => getMapState(state).initialViewBox;
